// import "./TastyStorySection.css";

// export default function TastyStorySection() {
//   return (
//     <section className="ts-section">
//       <p className="ts-top">OUR STORY ✦</p>

//       {/* Heading */}
//       <h2 className="ts-heading">
//         Enjoy Every Moment with Tasty <br />
//         <span className="ts-highlight">
//           <img src="https://images.unsplash.com/photo-1600891964599-f61ba0e24092" alt="" />
//           Breakfast,
//         </span>
//         Hearty
//         <span className="ts-highlight">
//           <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c" alt="" />
//           Mains
//         </span>
//         &
//         <span className="ts-highlight">
//           <img src="https://images.unsplash.com/photo-1510627498534-cf7e9002facc" alt="" />
//           Drinks
//         </span>
//       </h2>

//       <div className="ts-content">
//         {/* Left side text */}
//         <div className="ts-left">
//           <p className="ts-desc">
//             Lorem Ipsum is simply dummy text of the printing and typesetting
//             industry lorem Ipsum has been the industry’s standard dummy text
//             ever since the 1500s, when an unknown printer took a galley of
//             type and scrambled it to make a type specimen book. It has survived
//             not only five centuries, but also the leap into.
//           </p>

//           {/* Icons */}
//           <div className="ts-features">
//             <div className="ts-feature-box">
//               <span className="ts-icon">🍃</span>
//               <h4>HYGIENIC <br /> FOOD</h4>
//               <p>Lorem Ipsum is simply dummy text of the printing and type setting dummy text.</p>
//             </div>

//             <div className="ts-feature-box">
//               <span className="ts-icon">🏛️</span>
//               <h4>FRESH <br /> AMBIENCE</h4>
//               <p>Lorem Ipsum is simply dummy text of the printing and type setting dummy text.</p>
//             </div>
//           </div>

//           {/* Booking Row */}
//           <div className="ts-booking">
//             <div>
//               <p className="ts-book-label">Booking Request :</p>
//               <p className="ts-phone">+80 (400) 123 4567</p>
//             </div>

//             <button className="ts-btn">LEARN MORE</button>
//           </div>
//         </div>

//         {/* Right side image */}
//         <div className="ts-image-wrap">
//           <img
//             src="https://images.unsplash.com/photo-1559339352-11d035aa65de"
//             alt="Restaurant Interior"
//             className="ts-image"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

import "./TastyStorySection.css";

export default function TastyStorySection() {
  return (
    <section className="ts-section">
      <p className="ts-top">OUR STORY ✦</p>

      {/* Heading */}
      <h2 className="ts-heading">
        Celebrating Canadian Flavours <br />
        Inspired by Italian Cuisine — <br />
        Right Here in Sydney
      </h2>

      <div className="ts-content">
        {/* Left side text */}
        <div className="ts-left">
          <p className="ts-desc">
            At Nosh and Nector in Sydney, we serve freshly prepared, homemade Italian-Canadian cuisine made with high-quality ingredients. Inspired by Sydney’s vibrant food scene, we offer delicious breakfast, lunch, and dinner along with refreshing drinks in a warm and welcoming atmosphere.
          </p>

          <p className="ts-desc">
            We maintain strict hygiene and food safety standards to ensure every meal is prepared in a clean, safe, and professional kitchen. Dine inside our cozy wooden interior or relax on our beautiful waterfront patio with scenic views.
          </p>


          {/* Features */}
          <div className="ts-features">
            <div className="ts-feature-box">
              <span className="ts-icon">🌿</span>
              <h4>HYGIENIC <br /> FOOD</h4>
              <p>
                Homemade meals prepared in a fully sanitized kitchen using fresh
                ingredients and strict food safety standards for safe and
                healthy dining.
              </p>
            </div>

            <div className="ts-feature-box">
              <span className="ts-icon">🏛️</span>
              <h4>FRESH <br /> AMBIENCE</h4>
              <p>
                A clean, modern, and comfortable dining space designed to make
                you feel relaxed while enjoying homemade Canadian-inspired
                Italian flavours.
              </p>
            </div>
          </div>

          {/* Booking Row */}
          <div className="ts-booking">
            <div>
              <p className="ts-book-label">Booking Request:</p>
              <a href="tel:+19022702572" className="ts-phone">
                +1 902 270 2572
              </a>
            </div>

            <a href="tel:+19022702572">
              <button className="ts-btn">Connect to Call</button>
            </a>
          </div>

        </div>

        {/* Right side image */}
        <div className="ts-image-wrap">
          <img
            src="/assets/resto_images/hero.png"
            alt="Restaurant Interior"
            className="ts-image"
          />
        </div>
      </div>
    </section>
  );
}
